module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMklEQVQ4T2NgGBTgjoTcf3LwIDKAUav9Pzl4EBnw5zX/f3Iw9QwQmxT8nxw8iAwY2gAAheJDtCHF3K8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MU.png
// module id = 1217
// module chunks = 0